import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 23 * 3600 + 48 * 60 + 55;
function breakdown(total: number) {
  return {
    hours: Math.floor(total / 3600),
    minutes: Math.floor(total % 3600 / 60),
    seconds: total % 60
  };
}
export function AnnouncementBar() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const {
    hours,
    minutes,
    seconds
  } = breakdown(remaining);
  const units: {
    value: number;
    unit: string;
  }[] = [{
    value: hours,
    unit: 'godz'
  }, {
    value: minutes,
    unit: 'min'
  }, {
    value: seconds,
    unit: 'sek'
  }];
  return <div className="w-full bg-coral text-white" data-id="element-16" data-mp="1v9ii9y2144tq">
      <div className="mx-auto flex max-w-3xl items-center justify-center gap-3 px-4 py-3" data-id="element-17" data-mp="1v762nrjqu6ju">
        <HourglassIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-18" data-mp="1qayt7os52cx5" />
        <span className="text-[11px] font-bold uppercase tracking-[0.16em]" data-id="element-19" data-mp="67gx1mg7r9y9">
          Oferta wygasa za:
        </span>
        <span className="flex items-baseline gap-2" data-id="element-20" data-mp="ab6i41xoj9ej">
          {units.map((item, index) => <span key={item.unit} className="flex items-baseline gap-2" data-id="element-21" data-mp="3shb3c5jiqy3j" data-mpi={index}>
              {index > 0 && <span className="text-[11px] text-white/70" aria-hidden="true" data-id="element-22" data-mp="19fdl0evl8m9">
                  :
                </span>}
              <span className="text-[15px] font-bold tabular-nums" data-id="element-23" data-mp="txkypo9uczmm">
                {String(item.value).padStart(2, '0')}
              </span>
              <span className="text-[9px] font-semibold uppercase tracking-[0.14em] text-white/85" data-id="element-24" data-mp="f8f2m96avpiy">
                {item.unit}
              </span>
            </span>)}
        </span>
      </div>
    </div>;
}